export default __webpack_public_path__ + "static/media/create-appointment.c36acb2d.webp";